module.exports = __webpack_public_path__ + "arts-946e149a0010c2434b74c97148263b13.svg";